import {
  ParagraphSectionLayout,
  ParagraphTitle,
  TableContainer,
  TableRowContainer,
  TableShellTitle,
  TableShellValue,
} from "@frontend/common";

import EditableTextContainer from "@EditArticleContainer/shared/components/EditableTextContainer/EditableTextContainer";
import { DEALS_PARAGRAPH_CODE } from "@EditArticleContainer/shared/constants/editArticle.constants";
import { useParagraphEditedData } from "@EditArticleContainer/shared/hooks/useParagraph";
import { useUpdateParagraph } from "@EditArticleContainer/shared/hooks/useUpdateParagraph";
import { REF_CODE_FINANCIAL_TERMS_LASC_OTHER_TERMS } from "@EditArticleContainer/shared/libs/refCode/constants/refCode.constants";

import FinancialTermsLASCTableGroup from "./components/FinancialTermsLASCTableGroup/FinancialTermsLASCTableGroup";
import * as S from "./DealsParagraphFinancialTermsLASC.style";
import {
  hasMainTableItemValue,
  otherFinancialTermsLabels,
  otherFinancialTermsText,
} from "./utils/getFinancialTermsLASCShellValue";

const PARAGRAPH_TITLE = "Financial Terms";

const DealsParagraphFinancialTermsLASC = () => {
  const paragraph = useParagraphEditedData(
    DEALS_PARAGRAPH_CODE.financialTermsLASC,
  );
  const [updateParagraph, loadingIndex, updateKeyMap] = useUpdateParagraph({
    paragraphCode: DEALS_PARAGRAPH_CODE.financialTermsLASC,
    sectionCode: "TY002",
  });

  if (!paragraph) return null;

  const mainTable = paragraph.text["Main Financial Terms Table"];
  const otherTermsField = paragraph.text["Other Financial Terms"];

  // 값이 전혀 없는 테이블 그룹은 표출하지 않는다. (refKey 정합성을 위해 원본 index 유지)
  const visibleTables = mainTable
    .map((item, tableIndex) => ({ item, tableIndex }))
    .filter(({ item }) => hasMainTableItemValue(item));
  const hasOtherTerms = otherFinancialTermsText(otherTermsField).trim() !== "";

  // Financial Terms / Other Financial Terms 모두 값이 없으면 섹션 전체를 표출하지 않는다.
  if (visibleTables.length === 0 && !hasOtherTerms) return null;

  return (
    <ParagraphSectionLayout className="sub-section-wrapper">
      <ParagraphTitle title={PARAGRAPH_TITLE} type="section" />
      <S.ParagraphFinancialTermsLASCWrapper key={updateKeyMap.get(0)}>
        <S.ParagraphFinancialTermsLASCUpdateButton
          disabled={loadingIndex === 0}
          onClick={() => updateParagraph(0)}
        />
        {visibleTables.map(({ item, tableIndex }) => (
          <FinancialTermsLASCTableGroup
            key={`financial-terms-lasc-${String(tableIndex)}`}
            item={item}
            tableIndex={tableIndex}
          />
        ))}
        {hasOtherTerms && (
          <TableContainer>
            <TableRowContainer>
              <TableShellTitle>Other Financial Terms</TableShellTitle>
            </TableRowContainer>
            <TableRowContainer>
              <TableShellValue padding="0.2rem">
                <EditableTextContainer
                  item={{
                    text: otherFinancialTermsText(otherTermsField),
                    labels: otherFinancialTermsLabels(otherTermsField),
                  }}
                  refKey={REF_CODE_FINANCIAL_TERMS_LASC_OTHER_TERMS}
                  canTextEdit
                  style={{ padding: "0.8rem", borderRadius: "0" }}
                />
              </TableShellValue>
            </TableRowContainer>
          </TableContainer>
        )}
      </S.ParagraphFinancialTermsLASCWrapper>
    </ParagraphSectionLayout>
  );
};

export default DealsParagraphFinancialTermsLASC;
